<template>
  <div id="page-footer">
    <footer>
      <div class="bg-secondary">
        <b-container class="py-5">
          <img
            src="@/assets/CoActiveCare_logo_light_600.png"
            width="30%"
            alt="CoActive Care Logo"
          >
          <br>
          <p class="m-0 text-white">
            Registered Office:
            Georgian House, Park Hill Road, Torquay, TQ1 2DZ
          </p>
        </b-container>
      </div>
      <div class="bg-dark">
        <b-container class="py-3">
          <p class="m-0 text-white">
            <font-awesome-icon
              fixed-width
              icon="lock"
            />
            All your personal data is transmitted and stored using strong encryption
            and is not shared outside of CoActive Care.
          </p>
          <p class="m-0 text-white">
            &copy; CoActive Care {{ year }}
            &mdash;
            <a :href="$t('privacyUrl')">
              Legal &amp; Privacy Policy
            </a><br>
          </p>
        </b-container>
      </div>
      <cookie-banner />
    </footer>
  </div>
</template>

<script>
import CookieBanner from './CookieBanner.vue';

export default {
  components: {
    CookieBanner,
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
